/*
  This example requires Tailwind CSS v2.0+

  This example requires some changes to your config:

  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
*/
import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import MarkdownWrapper from "@/components/markdownWrapper";

export const query = graphql`
  fragment HeaderSimpleWithSelectMenuData on StrapiComponentHeaderSimpleWithSelectMenu {
    title
    topic
    description
  }
`;

function SimpleWithSelectMenu({ data, children }) {
  if (!data) {
    return <template />;
  }
  return (
    <div className="bg-background-white">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-24 lg:flex lg:justify-between lg:px-8">
        <div className="max-w-xl">
          {data.topic && (
            <h3 className="text-3xl tracking-tight text-text-white md:text-4xl">
              <MarkdownWrapper text={data.topic} />
            </h3>
          )}
          {data.title && (
            <h2 className="text-4xl font-extrabold text-text-primary sm:text-5xl sm:tracking-tight lg:text-6xl">
              <MarkdownWrapper text={data.title} />
            </h2>
          )}
          {data.description && (
            <MarkdownWrapper
              text={data.description}
              markdownClassName="mt-5 text-xl text-text-secondary"
              replaceParagraph={false}
            />
          )}
        </div>
        {children}
      </div>
    </div>
  );
}

SimpleWithSelectMenu.propTypes = {
  data: PropTypes.object,
};

export default SimpleWithSelectMenu;
